import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** DNA validator: writing phrase appears in runtime output from buildNormalizedDay + pilot utils. */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "לזהות את הפחד",
    opening: localizedGenderNode(
      [
      "היום אני לא דוחף/ת את עצמי.",
      "אני רק מזהה: יש בי פחד לצאת החוצה."
    ],
      [
      "היום אני לא דוחף/ת את עצמי.",
      "אני רק מזהה: יש בי פחד לצאת החוצה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מתי הפחד עולה הכי חזק?",
      "מה התסריט שמופיע מיד?",
      "מה אני מרגיש/ה בגוף?"
    ],
      [
      "מתי הפחד עולה הכי חזק?",
      "מה התסריט שמופיע מיד?",
      "מה אני מרגיש/ה בגוף?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "פחד הוא חוויה, לא הוראה."
    ],
      [
      "פחד הוא חוויה, לא הוראה."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת + \"אני רואה את הפחד\".",
      "נשימה אחת + \"אני רואה את הפחד\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "הרגע הראשון",
    opening: localizedGenderNode(
      [
      "היום אני שם/ה לב לרגע שהפחד מתחיל.",
      "אני רק מבחין/ה."
    ],
      [
      "היום אני שם/ה לב לרגע שהפחד מתחיל.",
      "אני רק מבחין/ה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני יושב/ת עם עצמי רגע.",
      "נשימה אחת."
    ],
      [
      "אני יושב/ת עם עצמי רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה קורה רגע לפני שאני בוחר/ת/ה לצאת?",
      "איזה מקום מרגיש הכי בטוח?",
      "מה אני מפחד/ת שיקרה בחוץ?"
    ],
      [
      "מה קורה רגע לפני שאני בוחר/ת/ה לצאת?",
      "איזה מקום מרגיש הכי בטוח?",
      "מה אני מפחד/ת שיקרה בחוץ?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "ברגע הראשון יש לי מעט מרחב."
    ],
      [
      "ברגע הראשון יש לי מעט מרחב."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת כשזה מתחיל.",
      "נשימה אחת כשזה מתחיל."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "אותות הגוף",
    opening: localizedGenderNode(
      [
      "היום אני מקשיב/ה לגוף לפני הסיפור.",
      "אני נשאר/ת איתי."
    ],
      [
      "היום אני מקשיב/ה לגוף לפני הסיפור.",
      "אני נשאר/ת איתי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני שם/ה לב לנשימה.",
      "נשימה אחת."
    ],
      [
      "אני שם/ה לב לנשימה.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איפה המתח יושב בגוף?",
      "מה הגוף מנסה להגן?",
      "מה יכול להרפות קצת?"
    ],
      [
      "איפה המתח יושב בגוף?",
      "מה הגוף מנסה להגן?",
      "מה יכול להרפות קצת?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "הגוף מנסה לשמור עלי."
    ],
      [
      "הגוף מנסה לשמור עלי."
    ]
    ),
    action: localizedGenderNode(
      "יד על החזה ונשימה אחת.",
      "יד על החזה ונשימה אחת."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "סיפור מול עובדה",
    opening: localizedGenderNode(
      [
      "היום אני מפריד/ה בין עובדה לסיפור.",
      "אני לא נלחם/ת בסיפור."
    ],
      [
      "היום אני מפריד/ה בין עובדה לסיפור.",
      "אני לא נלחם/ת בסיפור."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת פנימה והחוצה.",
      "נשימה אחת."
    ],
      [
      "אני נושם/ת פנימה והחוצה.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה העובדה היבשה כאן?",
      "איזה סיפור קפץ לי?",
      "איזו אפשרות רכה יכולה להיות גם אמת?"
    ],
      [
      "מה העובדה היבשה כאן?",
      "איזה סיפור קפץ לי?",
      "איזו אפשרות רכה יכולה להיות גם אמת?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סיפור הוא לא אני."
    ],
      [
      "סיפור הוא לא אני."
    ]
    ),
    action: localizedGenderNode(
      "משפט פנימי - \"זה סיפור שעולה\".",
      "משפט פנימי - \"זה סיפור שעולה\"."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "הפחד שמתחת",
    opening: localizedGenderNode(
      [
      "היום אני נוגע/ת בפחד שמתחת ליציאה.",
      "אני נשאר/ת איתו רגע."
    ],
      [
      "היום אני נוגע/ת בפחד שמתחת ליציאה.",
      "אני נשאר/ת איתו רגע."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט.",
      "נשימה אחת."
    ],
      [
      "אני נושם/ת לאט.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "ממה אני מפחד/ת שיקרה בחוץ?",
      "מה הכי כואב במחשבה הזו?",
      "מה הייתי בוחר/ת/ה לשמוע עכשיו?"
    ],
      [
      "ממה אני מפחד/ת שיקרה בחוץ?",
      "מה הכי כואב במחשבה הזו?",
      "מה הייתי בוחר/ת/ה לשמוע עכשיו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "פחד רוצה הגנה, לא מלחמה."
    ],
      [
      "פחד רוצה הגנה, לא מלחמה."
    ]
    ),
    action: localizedGenderNode(
      "לקרוא לפחד בשם בשקט.",
      "לקרוא לפחד בשם בשקט."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "מה נחשב בטוח",
    opening: localizedGenderNode(
      [
      "היום אני בודק/ת מה נותן לי תחושת בטחון.",
      "בלי שיפוט."
    ],
      [
      "היום אני בודק/ת מה נותן לי תחושת בטחון.",
      "בלי שיפוט."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מרגיש/ה את כפות הרגליים.",
      "נשימה אחת."
    ],
      [
      "אני מרגיש/ה את כפות הרגליים.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה המקום הבטוח שלי?",
      "מה אני מחזיק/ה ליד כדי להירגע?",
      "מה נותן לי תחושת קרקע?"
    ],
      [
      "מה המקום הבטוח שלי?",
      "מה אני מחזיק/ה ליד כדי להירגע?",
      "מה נותן לי תחושת קרקע?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "בטחון קטן יכול להספיק."
    ],
      [
      "בטחון קטן יכול להספיק."
    ]
    ),
    action: localizedGenderNode(
      "לבחור מילה אחת של בטחון.",
      "לבחור מילה אחת של בטחון."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "הצורך בביטחון",
    opening: localizedGenderNode(
      [
      "היום אני נוגע/ת בצורך בביטחון שמתחת לפחד.",
      "אני נשאר/ת איתי."
    ],
      [
      "היום אני נוגע/ת בצורך בביטחון שמתחת לפחד.",
      "אני נשאר/ת איתי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט.",
      "נשימה אחת."
    ],
      [
      "אני נושם/ת לאט.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה אני בוחר/ת/ה כדי להרגיש בטוח/ה?",
      "מה יכול לעזור לי לצאת קצת?",
      "מה הייתי רוצה לתת לעצמי עכשיו?"
    ],
      [
      "מה אני בוחר/ת/ה כדי להרגיש בטוח/ה?",
      "מה יכול לעזור לי לצאת קצת?",
      "מה הייתי רוצה לתת לעצמי עכשיו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "ביטחון קטן משנה את הטון."
    ],
      [
      "ביטחון קטן משנה את הטון."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב מילה אחת של ביטחון.",
      "לכתוב מילה אחת של ביטחון."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "להניח רגע",
    opening: localizedGenderNode(
      [
      "היום אני בודק/ת איך זה מרגיש להניח את הפחד לרגע.",
      "רק רגע."
    ],
      [
      "היום אני בודק/ת איך זה מרגיש להניח את הפחד לרגע.",
      "רק רגע."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נותן/ת לגוף להתרכך מעט.",
      "נשימה אחת."
    ],
      [
      "אני נותן/ת לגוף להתרכך מעט.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה קורה בי כשאני מניח/ה לרגע?",
      "מה מפחיד אותי בלהניח?",
      "מה מרגיע אותי אפילו קצת?"
    ],
      [
      "מה קורה בי כשאני מניח/ה לרגע?",
      "מה מפחיד אותי בלהניח?",
      "מה מרגיע אותי אפילו קצת?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "להניח לרגע זו גם בחירה."
    ],
      [
      "להניח לרגע זו גם בחירה."
    ]
    ),
    action: localizedGenderNode(
      "רגע אחד בלי להילחם בפחד.",
      "רגע אחד בלי להילחם בפחד."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "שפה פנימית רכה",
    opening: localizedGenderNode(
      [
      "היום אני בוחר/ת לדבר אל עצמי ברוך.",
      "לא בכוח."
    ],
      [
      "היום אני בוחר/ת לדבר אל עצמי ברוך.",
      "לא בכוח."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת ושם/ה לב לקול הפנימי.",
      "נשימה אחת."
    ],
      [
      "אני נושם/ת ושם/ה לב לקול הפנימי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איך אני מדבר/ת אל עצמי לפני היציאה?",
      "איך הייתי רוצה לשמוע את זה?",
      "מה המשפט הרך שלי?"
    ],
      [
      "איך אני מדבר/ת אל עצמי לפני היציאה?",
      "איך הייתי רוצה לשמוע את זה?",
      "מה המשפט הרך שלי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "קול רך מוריד לחץ."
    ],
      [
      "קול רך מוריד לחץ."
    ]
    ),
    action: localizedGenderNode(
      "לומר את המשפט הרך פעם אחת.",
      "לומר את המשפט הרך פעם אחת."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "רגע לפני נסיגה",
    opening: localizedGenderNode(
      [
      "היום אני עוצר/ת רגע לפני שאני נשאר/ת בבית.",
      "רק רגע."
    ],
      [
      "היום אני עוצר/ת רגע לפני שאני נשאר/ת בבית.",
      "רק רגע."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני שם/ה לב לדחף להימנע.",
      "נשימה אחת."
    ],
      [
      "אני שם/ה לב לדחף להימנע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה אני מנסה להגן עליו כשאני נמנע/ת?",
      "מה יקרה אם אצא קצת?",
      "מה יכול לתמוך בי רגע אחד?"
    ],
      [
      "מה אני מנסה להגן עליו כשאני נמנע/ת?",
      "מה יקרה אם אצא קצת?",
      "מה יכול לתמוך בי רגע אחד?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "רגע קטן משנה כיוון."
    ],
      [
      "רגע קטן משנה כיוון."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת לפני החלטה להישאר.",
      "נשימה אחת לפני החלטה להישאר."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "לחזור להווה",
    opening: localizedGenderNode(
      [
      "היום אני חוזר/ת לרגע הזה.",
      "אני איתי."
    ],
      [
      "היום אני חוזר/ת לרגע הזה.",
      "אני איתי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מרגיש/ה את משקל הגוף.",
      "נשימה אחת."
    ],
      [
      "אני מרגיש/ה את משקל הגוף.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה אני שומע/ת עכשיו?",
      "מה אני רואה סביבי?",
      "מה אני מרגיש/ה ממש ברגע הזה?"
    ],
      [
      "מה אני שומע/ת עכשיו?",
      "מה אני רואה סביבי?",
      "מה אני מרגיש/ה ממש ברגע הזה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "ההווה נותן לי קרקע."
    ],
      [
      "ההווה נותן לי קרקע."
    ]
    ),
    action: localizedGenderNode(
      "להרגיש את כפות הרגליים לרגע.",
      "להרגיש את כפות הרגליים לרגע."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "רגע לפני יציאה",
    opening: localizedGenderNode(
      [
      "היום אני עוצר/ת רגע לפני היציאה.",
      "רק רגע."
    ],
      [
      "היום אני עוצר/ת רגע לפני היציאה.",
      "רק רגע."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני שם/ה לב לדחף להישאר.",
      "נשימה אחת."
    ],
      [
      "אני שם/ה לב לדחף להישאר.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה יקרה אם אצא קצת?",
      "מה יכול לעזור לי להרגיש בטוח/ה שם?",
      "מה צעד קטן אחד אפשרי לי?"
    ],
      [
      "מה יקרה אם אצא קצת?",
      "מה יכול לעזור לי להרגיש בטוח/ה שם?",
      "מה צעד קטן אחד אפשרי לי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "צעד קטן הוא התחלה."
    ],
      [
      "צעד קטן הוא התחלה."
    ]
    ),
    action: localizedGenderNode(
      "לבחור צעד קטן אחד.",
      "לבחור צעד קטן אחד."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "צעד קטן",
    opening: localizedGenderNode(
      [
      "היום אני בוחר/ת צעד קטן שמרגיע אותי.",
      "לא מהפכה."
    ],
      [
      "היום אני בוחר/ת צעד קטן שמרגיע אותי.",
      "לא מהפכה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט ומביט/ה סביבי.",
      "נשימה אחת."
    ],
      [
      "אני נושם/ת לאט ומביט/ה סביבי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזה צעד קטן יכול לעזור לי לצאת?",
      "מתי אני יכול/ה לעשות אותו?",
      "מה יעזור לי לזכור?"
    ],
      [
      "איזה צעד קטן יכול לעזור לי לצאת?",
      "מתי אני יכול/ה לעשות אותו?",
      "מה יעזור לי לזכור?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "קטן מספיק הוא מספיק."
    ],
      [
      "קטן מספיק הוא מספיק."
    ]
    ),
    action: localizedGenderNode(
      "לבחור צעד קטן אחד.",
      "לבחור צעד קטן אחד."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "משפט חזרה",
    opening: localizedGenderNode(
      [
      "היום אני מסיים/ת עם משפט שמחזיר אותי לעצמי.",
      "אני בוחר/ת נוכחות."
    ],
      [
      "היום אני מסיים/ת עם משפט שמחזיר אותי לעצמי.",
      "אני בוחר/ת נוכחות."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע לפני תגובה.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע לפני תגובה.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה למדתי על הפחד הזה?",
      "מה הסימן הראשון שהוא עולה?",
      "מה המשפט הקצר שלי?"
    ],
      [
      "מה למדתי על הפחד הזה?",
      "מה הסימן הראשון שהוא עולה?",
      "מה המשפט הקצר שלי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "אני בוחר/ת רגע לפני תגובה."
    ],
      [
      "אני בוחר/ת רגע לפני תגובה."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת + המשפט שלי.",
      "נשימה אחת + המשפט שלי."
    ),
  },
].map(buildNormalizedDay);

export const fearLeavingSafePlacesBlueprintHe = buildNormalizedPilotBlueprint({
  id: "fear_leaving_safe_places_14d",
  version: "tri_locale_emit_he_v1",
  durationDays: 14,
  problemKey: "fear_leaving_safe_places",
  category: "anxiety",
  journeyName: {
    he: "פחד לצאת ממקומות בטוחים (\"מה אם יקרה התקף בחוץ\")",
    en: "Fear of leaving safe places (\"What if an attack happens outside\")",
    es: "Miedo a salir de lugares seguros (\"Y si ocurre un ataque afuera\")",
  },
  days,
});

export default fearLeavingSafePlacesBlueprintHe;
